<template>
  <div class="check_notice_wrap">
    <div class="check_notice_cont">
      <input
        class="amwa-checkbox"
        type="checkbox"
        name="chknotice"
        id="chknotice"
        v-model="localCheckNotice"
        @change="$emit('input', $event.target.checked)"
      />
      <label for="chknotice" class="focus"
        >영양 상담사의 상담 완료 후 결제가 완료되며, 결제가 완료되어야 제품을
        픽업 또는 배송받으실 수 있습니다.</label
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckNotice",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newVal) {
      this.localCheckNotice = newVal;
    },
  },
  data() {
    return {
      localCheckNotice: this.value,
    };
  },
};
</script>